import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MaskText, SectionLabel } from './ui/Reveal';
import { values } from '../data/site';

/** Interactive value list — the hovered/focused value reveals its note. */
export function Values() {
  const [active, setActive] = useState<number | null>(0);
  return <section className="bg-surface py-20 sm:py-28" aria-label="Core values" data-id="element-593" data-mp="2e81td7jry78j">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-594" data-mp="2t5u6xu5rglk3">
        <div className="grid gap-6 lg:grid-cols-[1fr_1fr] lg:items-end" data-id="element-595" data-mp="2t411gi6vw7do">
          <div data-id="element-596" data-mp="2o70tu2udywkg">
            <SectionLabel data-id="element-597" data-mp="2o56hhcx6kcrz">Core values</SectionLabel>
            <h2 className="mt-5 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tightest sm:text-6xl" data-id="element-598" data-mp="31xmenx3ehgkz">
              <MaskText text="What we|hold to" data-id="element-599" data-mp="2xxlzga8h91cv" />
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-muted sm:text-lg" data-id="element-600" data-mp="3bxn2nwc7skvi">
            Nine principles that decide how we work, what we ship and what we refuse to send out the
            door.
          </p>
        </div>

        <ul className="mt-12 flex flex-wrap gap-3 border-t border-line pt-10" data-id="element-601" data-mp="3r5u9twywge8r">
          {values.map((value, index) => {
          const isActive = active === index;
          return <li key={value.name} data-id="element-602" data-mp="4v86rzq9gmbm" data-mpi={index}>
                <button type="button" onMouseEnter={() => setActive(index)} onFocus={() => setActive(index)} onClick={() => setActive(index)} aria-pressed={isActive} className={`group flex items-baseline gap-3 border px-5 py-3 transition-colors duration-300 ${isActive ? 'border-brand bg-brand text-white' : 'border-line text-ink hover:border-brand hover:text-brand'}`} data-cursor="hover" data-id="element-603" data-mp="8xv3adxvmvf5">
                  <span className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl" data-id="element-604" data-mp="11m0ot2wr8og1">
                    {value.name}
                  </span>
                  <span className={`font-mono text-[0.6rem] uppercase tracking-[0.16em] ${isActive ? 'text-white/70' : 'text-muted'}`} data-id="element-605" data-mp="2xnkh0fmluxlv">
                    0{index + 1}
                  </span>
                </button>
              </li>;
        })}
        </ul>

        <motion.p key={active} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-10 max-w-2xl font-serif text-2xl italic leading-snug sm:text-4xl" data-id="element-606" data-mp="3hcl561lnr3c6">
          {active !== null ? values[active].note : 'Hover a value to read more.'}
        </motion.p>
      </div>
    </section>;
}